
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface OpeningHour {
  id: string;
  provider_id: string;
  day_of_week: number;
  open_time: string;
  close_time: string;
  is_closed: boolean;
  created_at: string;
}

export const useOpeningHours = (providerId: string) => {
  return useQuery({
    queryKey: ['opening_hours', providerId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('opening_hours')
        .select('*')
        .eq('provider_id', providerId)
        .order('day_of_week', { ascending: true });

      if (error) {
        console.error('Error fetching opening hours:', error);
        throw error;
      }

      return data as OpeningHour[];
    },
    enabled: !!providerId,
  });
};
